import { useState } from "react";
import MandataireForm from "./MandataireForm";
// @ts-expect-error pure js
import useMandataire from "../../hooks/use-mandataire";
// @ts-expect-error pure js
import { sanitizeValues } from "../../models/utils";
import BailleurProfileCard from "../Profile/BailleurProfileCard";
// @ts-expect-error pure js
import Spinner from "../UI/Spinner";
import EmptyState from "../UI/EmptyState";
import Button from "../UI/Button";
import { IconBriefcase, IconPlus } from "@tabler/icons-react";
import type { Mandataire as MandataireEntity } from "../../models/mandataire";
import styles from "./Mandataire.module.css";

export default function Mandataire() {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const { mandataire, createOrUpdateMandataire, isLoading } =
    useMandataire() as {
      mandataire: MandataireEntity | null;
      createOrUpdateMandataire: (
        values: Record<string, unknown>,
      ) => Promise<void>;
      isLoading: boolean;
    };

  async function submitHandler(values: Record<string, unknown>) {
    await createOrUpdateMandataire(sanitizeValues(values));
    setIsFormOpen(false);
  }

  return (
    <>
      <MandataireForm
        open={isFormOpen}
        onOpenChange={setIsFormOpen}
        mandataire={mandataire}
        onSubmit={submitHandler}
      />

      {isLoading ? (
        <div className={styles.spinner}>
          <Spinner width={"3em"} />
        </div>
      ) : mandataire ? (
        <BailleurProfileCard
          profile={mandataire.profile}
          onEdit={() => setIsFormOpen(true)}
        />
      ) : (
        <EmptyState
          icon={IconBriefcase}
          title="Aucun profil mandataire"
          description="Renseignez l'identité de votre agence, votre carte professionnelle et vos honoraires : ces informations alimentent vos mandats et vos documents."
        >
          <Button icon={IconPlus} onClick={() => setIsFormOpen(true)}>
            Ajouter un profil mandataire
          </Button>
        </EmptyState>
      )}
    </>
  );
}
